import { create } from '@bufbuild/protobuf'
import type { ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import {
  UploadDataType,
  UploadResult,
} from '@ebalance/proto/bffuser/v1/csv_upload_history_model_pb'
import { listCsvUploadHistories } from '@ebalance/proto/bffuser/v1/csv_upload_history_service-CsvUploadHistoryService_connectquery'
import {
  ListCsvUploadHistoriesRequestSchema,
  type ListCsvUploadHistoriesResponse,
} from '@ebalance/proto/bffuser/v1/csv_upload_history_service_pb'
import type { Date as ProtoDate } from '@ebalance/proto/google/type/date_pb'
import type { UseQueryResult } from '@tanstack/react-query'

export type ListCsvUploadHistoriesFilter = {
  dataTypeFilter?: UploadDataType
  uploadedByFilter?: string
  resultFilter?: UploadResult
  uploadedFrom?: ProtoDate
  uploadedTo?: ProtoDate
  page?: number
  pageSize?: number
}

/**
 * BFF CsvUploadHistoryService.ListCsvUploadHistories を TanStack Query で
 * 取得する hook (docs/specs/admin/data/uploads/history.md)。 一覧はデフォルトで
 * 全件表示で、期間フィルタで絞り込む
 * (docs/specs/admin/data/uploads/history.md 前提)。
 */
export function useListCsvUploadHistories(
  filter: ListCsvUploadHistoriesFilter = {},
): UseQueryResult<ListCsvUploadHistoriesResponse, ConnectError> {
  const req = create(ListCsvUploadHistoriesRequestSchema, {
    dataTypeFilter: filter.dataTypeFilter ?? UploadDataType.UNSPECIFIED,
    uploadedByFilter: filter.uploadedByFilter,
    resultFilter: filter.resultFilter ?? UploadResult.UNSPECIFIED,
    uploadedFrom: filter.uploadedFrom,
    uploadedTo: filter.uploadedTo,
    page: filter.page ?? 1,
    pageSize: filter.pageSize ?? 50,
  })

  return useQuery(listCsvUploadHistories, req)
}
